/**
 * Console Override for Production
 * Suppresses all console output in production to prevent information leakage
 */

const isProduction = process.env.NODE_ENV === 'production';

// Store original console methods
const originalConsole = {
  log: console.log,
  error: console.error,
  warn: console.warn,
  info: console.info,
  debug: console.debug,
  table: console.table,
  group: console.group,
  groupEnd: console.groupEnd,
  time: console.time,
  timeEnd: console.timeEnd
};

/**
 * Override console methods in production
 * This prevents any console output from appearing in browser DevTools (F12)
 */
export const suppressConsoleInProduction = () => {
  if (isProduction) {
    // Completely silence all console output in production
    console.log = () => {};
    console.error = () => {};
    console.warn = () => {};
    console.info = () => {};
    console.debug = () => {};
    console.table = () => {};
    console.group = () => {};
    console.groupEnd = () => {};
    console.time = () => {};
    console.timeEnd = () => {};

    // Log once to localStorage that console has been suppressed (won't show in console)
    try {
      localStorage.setItem('console_suppressed', 'true');
    } catch (e) {
      // Silently fail if localStorage is not available
    }
  }
};

/**
 * Restore original console methods (for development/debugging)
 * This can be called from browser DevTools if needed: window.__restoreConsole()
 */
export const restoreConsole = () => {
  console.log = originalConsole.log;
  console.error = originalConsole.error;
  console.warn = originalConsole.warn;
  console.info = originalConsole.info;
  console.debug = originalConsole.debug;
  console.table = originalConsole.table;
  console.group = originalConsole.group;
  console.groupEnd = originalConsole.groupEnd;
  console.time = originalConsole.time;
  console.timeEnd = originalConsole.timeEnd;

  console.log('Console restored');
};

// Make restore function available globally for emergency debugging
if (typeof window !== 'undefined') {
  window.__restoreConsole = restoreConsole;
}

export default suppressConsoleInProduction;
